export default function LipstickIcon({ size = 18, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="btc-gold" x1="8" y1="10" x2="16" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F1DA9A" />
          <stop offset="0.5" stopColor="#C9A227" />
          <stop offset="1" stopColor="#8C6E1C" />
        </linearGradient>
      </defs>
      {/* red lipstick bullet, slightly slanted at the top */}
      <path d="M9 9.5 V7 C9 5 10 4 12 4 L15 4.6 V9.5 Z" fill="#B11226" />
      <path d="M15 4.6 L12 4 C10 4 9 5 9 7 V7.6 L15 8.2 Z" fill="#D6203A" />
      {/* gold band */}
      <rect x="8.4" y="9.3" width="7.2" height="1.9" rx="0.6" fill="#7A5F16" />
      {/* gold tube */}
      <rect x="8.8" y="11" width="6.4" height="9.5" rx="1.4" fill="url(#btc-gold)" />
      <rect x="10.2" y="11.6" width="1" height="8.3" rx="0.5" fill="#F6E7B2" opacity="0.6" />
    </svg>
  );
}
